import axios from 'axios'
import { API_ENDPOINT } from "../../../config"
import Requests from "../../../utils/Requests"

const getDefaultState = () => {
    return {
        loadingTransactions: false,
        downloadingReceipt: false,
        criteria: {
            filter: "",
            filterValue: "",
            from: new Date().toString("yyyy-MM-dd"),
            to: new Date().toString("yyyy-MM-dd")
        },
        transactions: [],
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0
    }
}

const loadTransactions = instance => {

    if(instance.state.loadingTransactions){
        return
    }

    instance.setState({
        ...instance.state,
        loadingTransactions: true
    })

    const data = {
        page: instance.state.currentPage,
        size: instance.state.itemsPerPage,
        criteria: []
    }

    Requests(instance.props)
        .withPost()
        .withData(data)
        .withUrl('/api/finance/member/transactions')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleLoadTransactionsResponse(instance, response), error => handleError(instance, error))
}

const handleLoadTransactionsResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingTransactions: false,
                transactions: response.data.transactions,
                totalItems: response.data.size
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingTransactions: false
            })
            alert(response.message)
    }
}

const downloadReceipt = (instance, reference) => {

    if(instance.state.downloadingReceipt){
        return
    }

    instance.setState({
        ...instance.state,
        downloadingReceipt: true
    })

    const data = {
        reference: reference
    }

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/finance/member/transaction/receipt",
        responseType: 'arraybuffer',
        headers: {
            "Authorization": instance.props.auth.authorizationToken
        },
        data: data
    }).then(response => handleDownloadReceiptResponse(instance, response, reference))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loading: false
            })
            alert(error)
        })
}

const handleDownloadReceiptResponse = (instance, response, reference) => {

    instance.setState({
        ...instance.state,
        downloadingReceipt: false
    })

    if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Transaction-Receipt-' + reference+ '.pdf')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    } else {
        alert(response.data.message)
    }
}

const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        loadingTransactions: false,
        flag: {
            type: "",
            text: ""
        }
    })

    alert(error)
    
}

const Service = instance => {
    return {
        loadTransactions: () => loadTransactions(instance),
        getDefaultState: () => getDefaultState(),
        downloadReceipt: (reference) => downloadReceipt(instance, reference)
    }
}

export default Service